import { ruleTriggers } from '../queries';
import { useQuery } from 'react-apollo';

export function useRuleTriggers () {
  const { data: query , refetch: refresh, loading: isLoading, error } = useQuery(ruleTriggers, {
    fetchPolicy: 'cache-first',
  });
  let data = (query?.ruleTriggers || []).filter(row => (row.status === 'ENABLED')).map(row => ({
		id: row.dbId,
		name: row.name,
  }));
  if (error) {
    data = [{
      'id':1,
      'name':'Report Created',
    },{
      'id':2,
      'name':'Report Allocated',
    },{
      'id':3,
      'name':'Report Status Change',
    },{
      'id':4,
      'name':'Report Stage Change',
    },{
      'id':5,
      'name':'Reporting Date Reminder',
    },{
      'id':6,
      'name':'Investment Created',
    },{
      'id':7,
      'name':'Report Allocated To Investment',
    },{'id':8,'name':'Allocated Report Status Change'},{'id':9,'name':'Allocated Report Stage Change'}];
  }
  return {
    data,
    refresh,
    isLoading
  };
}
